// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import App from './App'
import router from './router/index.js'
import 'common/sass/index.scss'
import store from './store/index'
import api from './common/js/api'
import VueI18n from 'vue-i18n'
import en from './i18n/en'
import cn from './i18n/cn'
import es from './i18n/es'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(VueI18n)
Vue.use(ElementUI)

Vue.config.productionTip = false

// Vue.use(axios)
Vue.prototype.$http = axios

Vue.prototype.api = api

// 准备翻译的语言环境信息
const locales = {
  'cn': cn,
  'en': en,
  'es': es
}
const dateTimeFormats = {
  'en-US': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric'
    }
  },
  'es-ES': {
    short: {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    },
    long: {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    }
  },
  'ja-JP': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    }
  }
}
// 通过选项创建 VueI18n 实例
const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'cn', // 设置地区
  messages: locales, // 设置地区信息
  dateTimeFormats // 设置日期时间格式
})
new Vue({ i18n }).$mount('#app')
/* eslint-disable no-new */
new Vue({
  i18n,
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  render: h => h(App)
})

// 热更新
if (module.hot) {
  module.hot.accept(['./i18n/en', './i18n/es', './i18n/cn'], function () {
    i18n.setLocaleMessage('en', require('./i18n/en').default)
    i18n.setLocaleMessage('es', require('./i18n/es').default)
    i18n.setLocaleMessage('cn', require('./i18n/cn').default)
    // 同样可以通过 $i18n 属性进行热更新
    // app.$i18n.setLocaleMessage('en', require('./en').default)
    // app.$i18n.setLocaleMessage('ja', require('./ja').default)
  })
}




// WEBPACK FOOTER //
// ./src/main.js